export default __webpack_public_path__ + "static/media/loader.7d7455d6.gif";